import TurnstileAssignmentContainer from "../../../Component/Application/TurnstileAssignment/TurnstileAssignmentContainer";

const TurnstileAssignmentPage = () => {
    return (
        <div className="page-body">
            <TurnstileAssignmentContainer/>
        </div>
    );
};

export default TurnstileAssignmentPage;